import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";

const MarkupPopup = ({ visaRequest, onSave, onClose }) => {
  const [markup, setMarkup] = useState(0);
  const [supplierPrice, setSupplierPrice] = useState(0);
  const [customerPrice, setCustomerPrice] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (visaRequest) {
      setSupplierPrice(visaRequest.supplierPrice || 0);
      setMarkup(visaRequest.markUP || 0);
      // Calculate customer price based on supplier price + markup
      const calculatedCustomerPrice =
        (visaRequest.supplierPrice || 0) + (visaRequest.markUP || 0);
      setCustomerPrice(calculatedCustomerPrice);
    }
  }, [visaRequest]);

  const calculateTotal = () => {
    const supplier = parseFloat(supplierPrice) || 0;
    const markupValue = parseFloat(markup) || 0;
    return supplier + markupValue;
  };

  // Update customer price when markup changes
  const handleMarkupChange = (value) => {
    setMarkup(value);
    const supplier = parseFloat(supplierPrice) || 0;
    const markupValue = parseFloat(value) || 0;
    setCustomerPrice(supplier + markupValue);
  };

  // If you want customer price to be editable but still show the calculated total separately:
  const handleCustomerPriceChange = (value) => {
    setCustomerPrice(value);
    // If you want to calculate markup based on customer price change:
    const supplier = parseFloat(supplierPrice) || 0;
    const customer = parseFloat(value) || 0;
    const calculatedMarkup = customer - supplier;
    setMarkup(calculatedMarkup > 0 ? calculatedMarkup : 0);
  };

  const handleSave = async () => {
    if (!visaRequest) return;

    setIsLoading(true);
    try {
      const totalPrice = calculateTotal();

      const pricingData = {
        visaRequestId: visaRequest.visaRequestId,
        markUP: parseFloat(markup) || 0,
        customerPrice: parseFloat(customerPrice) || 0,
        totalPrice: totalPrice,
      };

      console.log("Sending pricing data:", pricingData);

      const url = `${config.UPDATEVISAMARKUP}`;
      const response = await apiService.put(url, pricingData);

      console.log("API response:", response);

      if (response && response.success) {
        onSave();
        onClose();
      } else {
        throw new Error(response?.message || "Failed to update pricing");
      }
    } catch (error) {
      console.error("Error saving pricing:", error);
      alert(`Error saving pricing: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="modal fade show d-block"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-sm" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Update Pricing (INR)</h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
              disabled={isLoading}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Supplier Price </label>
              <input
                type="number"
                className="form-control"
                value={supplierPrice}
                disabled
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Markup Amount </label>
              <input
                type="number"
                className="form-control"
                value={markup}
                onChange={(e) => handleMarkupChange(e.target.value)}
                min="0"
                step="0.01"
                disabled={isLoading}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Customer Price </label>
              <input
                type="number"
                className="form-control"
                value={customerPrice}
                onChange={(e) => handleCustomerPriceChange(e.target.value)}
                min="0"
                step="0.01"
                disabled
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Total Price </label>
              <input
                type="number"
                className="form-control fw-bold text-success"
                value={calculateTotal()}
                disabled
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarkupPopup;
